<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">
        <div class="columns">
            <div class="column is-12">
                <div class="card">
                    <div class="card-header" style="padding: 10px;">
                        <div class="columns">
                            <div class="column">
                                <b-select id="category" name="category" v-model="category" size="is-small">
                                    <option selected value="school">All</option>
                                    <option selected value="kelas">By Class</option>
                                    <option selected value="kumpulan">By Group</option>
                                    <option selected value="teachers">Teacher's/Supervisor's Activities</option>
                                    <option selected value="behavior">By Behavior</option>
                                </b-select>
                            </div>
                            <div class="column" v-show="(category=='school') || (category=='behavior')">
                                <b-select id="subCategory" name="subCategory" v-model="subCategory" size="is-small">
                                    <option value="student">Top Users</option>
                                    <option value="kelas">Top Classes/Departments</option>
                                    <option value="kumpulan">Top Groups</option>
                                </b-select>
                            </div>
                            <div class="column" style="width: 200px;">
                                <b-select id="kelasID" name="kelasID" v-model="kelasID" size="is-small" v-show="category=='kelas'">
                                    <option selected value="-1">Select Class</option>
                                    <option v-for="kelas in kelasList" :key="kelas._id" :value="kelas._id">{{ kelas.level }} {{ kelas.name }}</option>
                                </b-select>
                                <b-select id="kumpulanID" name="kumpulanID" v-model="kumpulanID" size="is-small" v-show="category=='kumpulan'">
                                    <option selected value="-1">Select Group</option>
                                    <option v-for="kumpulan in kumpulanList" :key="kumpulan._id" :value="kumpulan._id">{{ kumpulan.name }}</option>
                                </b-select>                                
                                <b-select id="behaviorID" name="behaviorID" v-model="behaviorID" size="is-small" v-show="category=='behavior'">
                                    <option selected value="-1">Select Behavior</option>
                                    <option v-for="behavior in behaviorList" :key="behavior._id" :value="behavior._id">{{ behavior.name }}</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <b-select id="durationType" name="durationType" v-model="durationType" size="is-small">
                                    <option value="1" selected>Monthly/Yearly</option>
                                    <option value="2" v-show="category != 'teachers'">Month Range</option>
                                    <option value="3">Date Range</option>
                                </b-select>
                            </div>
                            <div class="column" v-show="durationType == 1">
                                <b-select id="duration" name="duration" v-model="duration" size="is-small">
                                    <option v-for="item in yearlyMonthlyDurationList" :key="item.value" :value="item.value">{{ item.label }}</option>
                                </b-select>
                            </div>
                            <div class="column is-3" v-show="durationType == 2">
                                <table><tr><td>
                                <b-select id="durationStartMonth" name="durationStartMonth" v-model="durationStartMonth" size="is-small">
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </b-select>
                                </td>
                                <td><b-select id="durationStartMonthYear" name="durationStartMonthYear" v-model="durationStartMonthYear" size="is-small">
                                    <option v-for="item in yearList" :key="item.value" :value="item.value">{{ item.label }}</option>
                                </b-select>
                                </td>
                                <td style="padding-right: 5px; padding-left: 5px; padding-top: 5px; font-size: 14px;">to</td><td>
                                <b-select id="durationEndMonth" name="durationEndMonth" v-model="durationEndMonth" size="is-small">
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </b-select>
                                </td>
                                <td><b-select id="durationEndMonthYear" name="durationEndMonthYear" v-model="durationEndMonthYear" size="is-small">
                                    <option v-for="item in yearList" :key="item.value" :value="item.value">{{ item.label }}</option>
                                </b-select>
                                </td>
                                </tr></table>
                            </div>
                            <div class="column is-3" v-show="durationType == 3">                                
                                <FunctionalCalendar
                                    v-model="calendarData"
                                        :isAutoCloseable="false"
                                        :is-modal='true' :is-date-range='true'
                                        :maxSelDays='60'
                                        :date-format="'dd/mm/yyyy'"
                                        :is-date-picker="true" 
                                ></FunctionalCalendar>
                            </div>
                            <div class="column">
                                <b-button type="is-link is-small" v-on:click="getLeaderboard()" style="margin-left: 10px;">Display</b-button>
                            </div>
                            <div class="column">
                                <b-select id="display" name="display" v-model="display" size="is-small">
                                    <option value="1">Top 10</option>
                                    <option value="2">Top 20</option>
                                    <option value="3">Top 30</option>
                                    <option value="4">Top 40</option>
                                    <option value="5">Top 50</option>
                                    <option value="6">Top 100</option>
                                    <option value="7">Top 300</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <b-select id="sortTopTeachers" name="sortTopTeachers" v-model="sortTopTeachers" size="is-small" style="margin-left: 10px;" @input="sortTeachersAndPoints(topTeachers)" v-show="category=='teachers'">
                                    <option value="0">By Name</option>
                                    <option value="1">By Points</option>
                                    <option value="2">By Scan Count</option>
                                </b-select>
                            </div>
                        </div>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="false">
                        </loading>
                        <div v-show="displayCategory=='students'">
                            <div class="columns">
                                <div class="column is-8"><b-button rounded>Top Students/Users</b-button></div>
                                <div class="column"><b-button size="is-small" rounded class="lastUpdatedStyle" v-show="isCached==true">Last updated on {{ moment(lastUpdated).format('LLLL') }}</b-button></div>
                            </div>
                            <div class="columns">
                                <div class="column"><b-table :data="sortTop(topStudents,display,'student')" :columns="topStudentsColumns" :mobile-cards="false"></b-table></div>
                            </div>
                        </div>
                        <div v-show="displayCategory=='teachers'">
                            <div class="columns">
                                <div class="column is-8"><b-button rounded>Top Teachers/Supervisors</b-button></div>
                                <div class="column"><b-button size="is-small" rounded class="lastUpdatedStyle" v-show="isCached==true">Last updated on {{ moment(lastUpdated).format('LLLL') }}</b-button></div>
                            </div>
                            <div class="columns">
                                <div class="column"><b-table :data="sortTeachersAndPoints(topTeachers)" :columns="topTeachersColumns" :mobile-cards="false" @click="goTeacherActivitiesView($event)"></b-table></div>
                            </div>
                        </div>
                        <div v-show="displayCategory=='kelas'">
                            <div class="columns">
                                <div class="column is-8"><b-button rounded>Top Classes/Departments</b-button></div>
                                <div class="column"><b-button size="is-small" rounded class="lastUpdatedStyle" v-show="isCached==true">Last updated on {{ moment(lastUpdated).format('LLLL') }}</b-button></div>
                            </div>
                            <div class="columns">
                                <div class="column"><b-table :data="sortTop(topClasses,display,'class')" :columns="topClassesColumns" :mobile-cards="false"></b-table></div>
                            </div>
                        </div>
                        <div v-show="displayCategory=='kumpulan'">
                            <div class="columns">
                                <div class="column is-8"><b-button rounded>Top Groups</b-button></div>
                                <div class="column"><b-button size="is-small" rounded class="lastUpdatedStyle" v-show="isCached==true">Last updated on {{ moment(lastUpdated).format('LLLL') }}</b-button></div>
                            </div>
                            <div class="columns">
                                <div class="column"><b-table :data="sortTop(topGroups,display,'group')" :columns="topGroupsColumns" :mobile-cards="false"></b-table></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./public/style.scss";
const helper = require("../../config/helper")
import { FunctionalCalendar } from 'vue-functional-calendar';

export default {
    name: "Leaderboard",
    components: {
        NewTopMenu,
        Loading,
        FunctionalCalendar
    },
    data() {
        return {
            calendarData: {},
            yearlyMonthlyDurationList: [],
            baseYear: 2021,
            yearList: [],
            schoolID: "",
            kelasID: "-1",
            kelasList: [],
            kumpulanID: "-1",
            behaviorID: "-1",
            kumpulanList: [],
            behaviorList: [],
            topStudents: [],
            topClasses: [],
            topGroups: [],
            isLoading: false,
            behaviorName: "",
            category: "school",
            subCategory: "student",
            duration: "",
            durationDisplay: "",
            durationType: 1,
            durationStartMonth: 1,
            durationStartMonthYear: 2021,
            durationEndMonth: 1,
            durationEndMonthYear: 2021,
            durationStartDaily: 1,
            durationEndDaily: 1,
            currentDay: 0,
            currentYear: 0,
            lastYear: 0,
            currentMonth: 0,
            display: 6,
            displayCategory: "",
            topTeachers: [],
            sortTopTeachers: 1,
            teacherTotalScanCount: 0,
            teacherTotalPoints: 0,
            selectedTeacher: null,
            isCached: false,
            props: [],
            lastUpdated: "",
            topStudentsColumns: [
                {
                        field: 'number',
                        label: '#',
                        width: '20',
                        numeric: true
                },
                {
                    field: 'firstName',
                    label: 'Name',
                },
                {
                    field: "class",
                    label: '',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points',
                    centered: true
                }
            ],
            topClassesColumns: [
                {
                    field: 'number',
                    label: '#',
                    width: '20',
                    numeric: true
                },
                {
                    field: "class",
                    label: 'Class/Department',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points',
                    centered: true
                }
            ],
            topGroupsColumns: [
                {
                    field: 'number',
                    label: '#',
                    width: '20',
                    numeric: true
                },
                {
                    field: "name",
                    label: 'Group',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points',
                    centered: true
                }
            ],
            topTeachersColumns: [
                {
                    field: 'number',
                    label: '#',
                    width: '20',
                    numeric: true
                },
                {
                    field: "name",
                    label: 'Name',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points Awarded',
                    centered: true
                },
                {
                    field: 'tempNumber2',
                    label: 'Scan Count',
                    centered: true
                }
            ],
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');

        var today = new Date();
        this.currentYear = today.getFullYear();
        this.lastYear = this.currentYear - 1
        this.currentMonth = today.getMonth() + 1;  //since month starts from 0
        this.currentDay = today.getDate();
        this.duration = this.currentMonth

        this.durationStartMonth = this.currentMonth
        this.durationEndMonth = this.currentMonth

        this.durationStartDaily = new Date(this.currentYear, this.currentMonth - 1,this.currentDay )
        this.durationEndDaily = new Date(this.currentYear, this.currentMonth - 1,this.currentDay )

        console.log("355 this.durationStartMonth: " + this.durationStartMonth)

        this.getClassList()
        this.getGroupList()        
        this.getBehaviorList()
        this.generateYearList()
        this.generateYearlyMonthlyDurationList()
    },
    mounted(){
    },
    methods: {
        generateYearList(){
            for (var i = this.currentYear; i >= this.baseYear; i--){
                var getYearList = {
                    value: i,
                    label: i
                }
                this.yearList.push(getYearList)
                if (i == this.currentYear){
                    this.durationStartMonthYear = i   //set's the default selected value
                    this.durationEndMonthYear = i   //set's the default selected value
                }
            }
        },
        generateYearlyMonthlyDurationList(){
            console.log("346 this.currentYear: " + this.currentYear)
            console.log("346 this.currentMonth: " + this.currentMonth)

            this.yearlyMonthlyDurationList = []

            //for current year
            for (var i = this.currentMonth; i >= 1; i--){
                var getMonth = i;
                if (getMonth < 10){
                    getMonth = "0" + getMonth
                }
                var yearMonth = this.currentYear + "" + getMonth
                var getYearMonth = {
                    value: yearMonth,
                    label: helper.displayMonth(getMonth) + " " + this.currentYear
                }
                this.yearlyMonthlyDurationList.push(getYearMonth)
                if (i == this.currentMonth){
                    this.duration = yearMonth   //set's the default selected value
                }
            }
            var getYear = {
                value: this.currentYear,
                label: this.currentYear
            }
            this.yearlyMonthlyDurationList.push(getYear)
            if (this.currentYear > 2021){
                //later on year 2022 and above need to do for the past years too, until year 2021 only
            }
        },
        async getLeaderboard(output){
            let self = this
            var durationDisplay = "";
            var setDurationStartDaily = "";
            var setDurationEndDaily = "";
            var categoryName = ""

            if (self.durationType == 1){
                self.duration = self.duration + "" //convert it to string so we can get the length
                console.log(self.duration)
                if (self.duration.length == 4){
                    durationDisplay = self.duration
                }else{
                    var displayMonth = helper.displayMonth(self.duration.substring(4,6))
                    durationDisplay = displayMonth + " " + self.duration.substring(0,4)
                }

            }else if (self.durationType == 2){
                //monthly range
                var displayStartMonth = helper.displayMonth(self.durationStartMonth)
                var displayEndMonth = helper.displayMonth(self.durationEndMonth)
                durationDisplay = displayStartMonth + " " + self.durationStartMonthYear + " to " + displayEndMonth + " " + self.durationEndMonthYear

            }else if (self.durationType == 3){
                console.log(this.calendarData)
                //daily range
                this.durationStartDaily = this.calendarData.dateRange.start
                this.durationEndDaily = this.calendarData.dateRange.end
                var getDay = this.durationStartDaily.substring(0,this.durationStartDaily.indexOf("/"))
                var tempStartDate = this.durationStartDaily.substring(this.durationStartDaily.indexOf("/")+1)
                var getMonth = tempStartDate.substring(0,tempStartDate.indexOf("/"))
                var getYear = tempStartDate.substring(tempStartDate.indexOf("/")+1)
                if (getDay < 10){
                    getDay = "0" + getDay
                }
                if (getMonth < 10){
                    getMonth = "0" + getMonth
                }
                setDurationStartDaily = getYear + "" + getMonth + "" + getDay
                console.log("442 setDurationStartDaily: " + setDurationStartDaily)
                
                getDay = this.durationEndDaily.substring(0,this.durationEndDaily.indexOf("/"))
                var tempEndDate = this.durationEndDaily.substring(this.durationEndDaily.indexOf("/")+1)
                getMonth = tempEndDate.substring(0,tempEndDate.indexOf("/"))
                getYear = tempEndDate.substring(tempEndDate.indexOf("/")+1)

                if (getDay < 10){
                    getDay = "0" + getDay
                }
                if (getMonth < 10){
                    getMonth = "0" + getMonth
                }
                setDurationEndDaily = getYear + "" + getMonth + "" + getDay
                console.log("450 setDurationEndDaily: " + setDurationEndDaily)

                durationDisplay = setDurationStartDaily + " to " + setDurationEndDaily
            }

            console.log("449 durationDisplay: " + durationDisplay)
            console.log("451 self.duration: " + self.duration)
            
            self.topStudents = []
            self.topClasses = []
            self.topGroups = []

            if ((self.category == "school") || (self.category == "behavior")){
                if (self.subCategory == "student"){
                    self.displayCategory = "students"
                }else if (self.subCategory == "kelas"){
                    self.displayCategory = "kelas"
                }else if (self.subCategory == "kumpulan"){
                    self.displayCategory = "kumpulan"
                }else{
                    console.log("431 invalid subCategory!")
                }
            }else if ((self.category == "kelas") || (self.category == "kumpulan")){
                self.displayCategory = "students"   //because we're showing STUDENTS inside the class or group
            }else if (self.category == "teachers"){
                self.displayCategory = "teachers"
                if (self.durationType == 2){
                    Toast.open({
                        message: "Sorry, month range is not available for teacher's/supervisor's activities",
                        type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;                    
                }
            }else{
                self.displayCategory = self.category
            }

            if (self.category == "behavior"){
                if (self.behaviorID == "-1"){
                    Toast.open({
                        message: "Please select the class first",
                        type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }

            }else if (self.category == "kelas"){
                if (self.kelasID == "-1"){
                    Toast.open({
                        message: "Please select the class first",
                        type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }
                var findKelasID = self.kelasID
                let selectedCategory = _.find(self.kelasList, {'_id': findKelasID});
                categoryName = selectedCategory.level + " " + selectedCategory.name
                self.topStudents = []

            }else if (self.category == "kumpulan"){
                if (self.kumpulanID == "-1"){
                    Toast.open({
                        message: "Please select the group first",
                        type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }
                var findKumpulanID = self.kumpulanID
                let selectedCategory = _.find(self.kumpulanList, {'_id': findKumpulanID});
                categoryName = selectedCategory.name
                self.topStudents = []

            }else if (self.category == "teachers"){
                categoryName = "Teacher's Activities"
                self.topTeachers = []
            }

            if (output == "excel"){
                axios.defaults.responseType = 'blob'
            }else{
                output = "";
                axios.defaults.responseType = 'json'
            }
            self.isLoading = true

            var setStartMonth = self.durationStartMonth
            var setEndMonth = self.durationEndMonth
            if (setStartMonth < 10){
                setStartMonth = "0" + setStartMonth
            }
            if (setEndMonth < 10){
                setEndMonth = "0" + setEndMonth
            }

            if ((self.category == "school") && (self.subCategory == "kumpulan")){
                var isYearly = false
                var year = 0
                if (self.durationType == "1"){
                    if (self.duration.length == 4){
                        isYearly = true
                        year = self.duration
                    }
                }
                var durationStart = ""
                var durationEnd = ""
                if (!isYearly){
                    if (self.durationType == "1"){
                        //since yearly is handled above, self.duration here will only contain month
                        durationStart = self.duration + "01"
                        durationEnd = self.duration + "" + helper.getDaysInMonth(self.duration,self.currentYear)
                        
                    }else if (self.durationType == "2"){

                        var getStartMonth = self.durationStartMonth
                        var getEndMonth = self.durationEndMonth
                        if (getStartMonth < 10){
                            getStartMonth = "0" + getStartMonth
                        }
                        if (getEndMonth < 10){
                            getEndMonth = "0" + getEndMonth
                        }
                        var startYearMonth = self.durationStartMonthYear + "" + getStartMonth
                        var endYearMonth = self.durationEndMonthYear + "" + getEndMonth

                        durationStart = startYearMonth + "01"
                        durationEnd = endYearMonth + "" + helper.getDaysInMonth(self.durationEndMonth,self.durationEndMonthYear)

                    }else if (self.durationType == "3"){
                        durationStart = setDurationStartDaily
                        durationEnd = setDurationEndDaily
                    }
                }
                console.log("category: " + self.subCategory + " and isYearly: " + isYearly + " and year: " + year + " and durationStart: " + durationStart + " and durationEnd: " + durationEnd)
                console.log("581 to " + process.env.MY_URL + '/leaderboardV3/topCategory')
                axios.post(process.env.MY_URL + '/leaderboardV3/topCategory', {
                    token: localStorage.getItem('jwtTokenV2'),
                    email: localStorage.getItem('email'),
                    category: self.subCategory,
                    isYearly: isYearly,
                    year: year,
                    durationStart: durationStart,
                    durationEnd: durationEnd
                })
                .then(response => {
                    self.isLoading = false
                    console.log("593 response.data")
                    console.log(response.data)

                    if (self.subCategory == "kumpulan"){
                        self.topGroups = response.data.groupList
                        self.lastUpdated = response.data.lastUpdated
                        self.isCached = response.data.isCached
                        for (var i = 0; i < self.topGroups.length; i++){
                            self.topGroups[i].tempNumber1 = parseFloat(self.topGroups[i].totalPoints)
                        }
                    }
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading = false
                    if (e.response.status === 401) {
                        Toast.open({
                            message: "Unauthorized access. Please re-login.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            message: 'Error: ' + e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }
                })

            }else{
                console.log("613 to " + process.env.MY_URL + '/leaderboardV2New/list')
                axios.post(process.env.MY_URL + '/leaderboardV2New/list', {
                    token: localStorage.getItem('jwtTokenV2'),
                    email: localStorage.getItem('email'),
                    category: self.category,
                    subCategory: self.subCategory,
                    kelasID: self.kelasID,
                    kumpulanID: self.kumpulanID,
                    behaviorID: self.behaviorID,
                    duration: self.duration,
                    durationType: self.durationType,
                    durationStartMonth: self.durationStartMonthYear + "" + setStartMonth,
                    durationEndMonth: self.durationEndMonthYear + "" + setEndMonth,
                    durationStartDaily: setDurationStartDaily,
                    durationEndDaily: setDurationEndDaily
                })
                .then(response => {
                    if (self.category == "teachers"){
                        self.topTeachers = response.data.teacherList
                        self.teacherTotalScanCount = response.data.totalCount
                        self.teacherTotalPoints = 0
                        for (var i = 0; i < self.topTeachers.length; i++){
                            self.teacherTotalPoints = self.teacherTotalPoints + parseFloat(self.topTeachers[i].tempNumber1)
                        }
                        self.lastUpdated = response.data.lastUpdated
                        self.isCached = response.data.isCached
                    }else{
                        if ((self.category == "school") || (self.category == "behavior")){
                            if (self.subCategory == "kelas"){
                                self.topClasses = response.data.kelasList
                                self.lastUpdated = response.data.lastUpdated
                                self.isCached = response.data.isCached
                                for (var i = 0; i < self.topClasses.length; i++){
                                    self.topClasses[i].tempNumber1 = parseFloat(self.topClasses[i].tempNumber1)
                                }
                            }else if (self.subCategory == "kumpulan"){
                                self.topGroups = response.data.groupList
                                self.lastUpdated = response.data.lastUpdated
                                self.isCached = response.data.isCached
                                for (var i = 0; i < self.topGroups.length; i++){
                                    self.topGroups[i].tempNumber1 = parseFloat(self.topGroups[i].tempNumber1)
                                }
                            }else{
                                self.topStudents = response.data.studentList
                                self.lastUpdated = response.data.lastUpdated
                                self.isCached = response.data.isCached
                                for (var i = 0; i < self.topStudents.length; i++){
                                    var lastName = ""
                                    if (self.topStudents[i].lastName && self.topStudents[i].lastName.length > 0){
                                        lastName = self.topStudents[i].lastName
                                    }
                                    self.topStudents[i].firstName = self.topStudents[i].firstName + " " + lastName
                                    self.topStudents[i].tempNumber1 = parseFloat(self.topStudents[i].tempNumber1)
                                }
                            }
                        }else if ((self.category == "kelas") || (self.category == "kumpulan")){
                            self.topStudents = response.data.studentList
                            self.lastUpdated = response.data.lastUpdated
                            self.isCached = response.data.isCached
                        }
                    }
                    self.isLoading = false
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading = false
                    if (e.response.status === 401) {
                        Toast.open({
                            message: "Unauthorized access. Please re-login.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            message: 'Error: ' + e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }
                })

            }

        },
        displayDate(date){
            try{
                var getYear = date.substring(0,4);
                var getMonth = date.substring(4,6);
                var getDay = date.substring(6);

                return getDay + "/" + getMonth + "/" + getYear;
            }catch(err){
                console.log(err)
                return date;
            }
        },
        displayInfo(dataType,remarks,status){
            if (dataType == 2){
                if (status == 2){
                    return "Late"
                }else{
                    return "On-Time"
                }
            }else{
                return remarks
            }
        },
        getClassList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/classes/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.kelasList = response.data.kelasList                
            })
            .catch(e => {
                console.log(e)
            })
        },
        getGroupList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/kumpulan/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.kumpulanList = response.data.kumpulanList
            })
            .catch(e => {
                console.log(e)
            })
        },
        getBehaviorList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.behaviorList = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        sortTop(arrays,display,what){
            var show = 100
            display = parseInt(display)
            switch(display) {
                case 1:
                    show = 10
                    break;
                case 2:
                    show = 20
                    break;
                case 3:
                    show = 30
                    break;
                case 4:
                    show = 40
                    break;
                case 5:
                    show = 50
                    break;
                case 6:
                    show = 100
                    break;
                case 7:
                    show = 300
                    break;
                default:
                    show = 100
                    // code block
            }
            var output = _.orderBy(arrays, 'tempNumber1', 'desc').splice(0,show); //we're using the magical lodash function here to sort by points and return the top needed
            for (var i = 0; i < output.length; i++){
                output[i].number = i + 1
                if (what=="student"){
                    if (this.category == "kelas"){
                        console.log("sini ke 714")
                        // output[i].class = this.getKelasName(this.kelasID)    //commented out, sbb akan confusekan user, sbb dia akan display terus nama kelas although belum update data kelas yg baru dipilih tu. fikir nnt camner nak buat ni
                    }else{
                        if (output[i].kelasID){
                            output[i].class = output[i].kelasID.level + " " + output[i].kelasID.name
                        }
                    }
                }else if (what=="class"){
                    output[i].class = output[i].level + " " + output[i].name
                }
                output[i].tempNumber1 = this.roundTo2DecimalPlaces(output[i].tempNumber1)
            }
            return output
        },
        sortTeachersAndPoints(arrays){
            var output;
            if (this.sortTopTeachers == 1){  //points
                output = _.orderBy(arrays, 'tempNumber1', 'desc');  //we're using the magical lodash function here
            }else if (this.sortTopTeachers == 2){  //scan count
                output = _.orderBy(arrays, 'tempNumber2', 'desc');  //we're using the magical lodash function here
            }else{  //name
                output = _.orderBy(arrays, 'firstName', 'asc');  //we're using the magical lodash function here
            }
            for (var i = 0; i < output.length; i++){
                output[i].number = i + 1
                output[i].name = output[i].firstName
                output[i].tempNumber1 = this.roundTo2DecimalPlaces(output[i].tempNumber1)
            }
            return output
        },
        getKelasName(kelasID){
            var findKelas = _.find(this.kelasList, {'_id': kelasID})    //use lodash to find particular object inside array
            var kelasLevelName = "";
            if (findKelas){
                kelasLevelName = findKelas.level + " " + findKelas.name
            }
            return kelasLevelName;
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
        goTeacherActivitiesView(data){
            console.log("goTeacherActivitiesView with this.duration: " + this.duration)
            console.log(data._id)
            console.log(data.name)
            this.$store.commit('UPDATE_TEACHER_ID',data._id)
            this.$store.commit('UPDATE_TEACHER_NAME',data.name)
            this.$store.commit('UPDATE_DURATION',this.duration)
            localStorage.setItem('TEACHER_ID',data._id)
            localStorage.setItem('TEACHER_NAME',data.name)
            localStorage.setItem('DURATION',this.duration)
            this.$router.push({
                name: "TeacherActivitiesView"
            });
        },
    },
};
</script>

<style scoped>
.bottom-border{
    border-bottom: 1px solid #CCC
}
.container{
    padding: 10px;
}
.text-center{
    text-align: center;
}
.lastUpdatedStyle{
    margin-top: 10px;
    font-style: italic;
}
.card-content{
    min-height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/LeaderboardV3.vue